export function workspaceViewEvent() {
  gtag('event', 'workspace_view')
}
